import { useState } from 'react'
import { Box, Grid2, Typography } from '@mui/material'
import CustomDivider from '../../shared/utils/CustomDivider'
import { useAllUserList } from '../../assets/api/useAdminApi'
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate'
import { LocationFilterFields } from '../../shared/components/LocationFilterFields'

const ChroHRList = () => {
    const [filters, setFilters] = useState({});
    const { data: allUserList, isLoading } = useAllUserList({ role: "HR", ...filters })
    const allUserOption = allUserList?.data?.map((item, index) => ({
        sr_no: index + 1,
        ...item
    }))
    const alluserColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "firstname",
            headerName: "First Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params?.row?.role === "student" ? params?.row?.lastname : params.value}</Typography>,
        },

        {
            field: "lastname",
            headerName: "Last Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params?.row?.role === "student" ? "" : params.value}</Typography>,
        },
        {
            field: "role",
            headerName: "Role",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "username",
            headerName: "Username",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "email",
            headerName: "Email",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "mobile",
            headerName: "Mobile",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },

    ];




    return (
        <Box>

            <CustomDivider />
            <TableFilterTemplate
                title="HR List"
                columns={alluserColumns}
                rowsData={allUserOption || []}
                isLoading={isLoading}
                filterInitialValues={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}
                renderFilterFields={() => (
                    <>
                        <LocationFilterFields
                            countryField="country_name"
                            stateField="state"
                            cityField="city"
                            isStoredId={false}
                        />
                    </>
                )}
            />



        </Box>
    )
}

export default ChroHRList
